import React from 'react';
import WithholdingCalculator from './WithholdingCalculator';

function App() {
  return (
    <div className="page-container">
      <header className="header">
        <div className="header-container">
          <a href="https://essentialx.us/" className="header-logo">Essential X</a>
          <nav className="header-nav">
            <a href="mailto:contact@essentialx.us" className="nav-link">Contact</a>
          </nav>
        </div>
      </header>
      <main>
        <WithholdingCalculator />
      </main>
      <footer className="footer">
        <p>© 2026 Essential X, All Rights Reserved. | <a href="https://www.linkedin.com/company/essentialx/" target="_blank" rel="noopener noreferrer">Our LinkedIn</a></p>
      </footer>
    </div>
  );
}

export default App;